import { TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import React from "react";
import { ProfileFormProps } from "../types/profile-form";
// import { ProfileFormProps } from '../types/profile-form';

interface BioInputProps {
  formik: FormikProps<ProfileFormProps>;
  name: keyof ProfileFormProps;
  label: string;
  type: string;
  placeholder?: string;
  helperText?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  adornment?: {
    text: string;
    onClick: () => void;
  };
  options?: { value: string; label: string }[];
  verified?: boolean;
  value?: string;
}

const BioFieldInput: React.FC<BioInputProps> = ({ name, formik, value }) => {
  return (
    <>
      <Typography variant="h6" mb={1} fontFamily="Maven Pro, sans-serif">
        Bio*
        <Typography variant="caption" color="text.primary" ml={2} fontSize={14}>
          (an introduction about your company)
        </Typography>
      </Typography>
      <TextField
        name={name}
        sx={{ width: { xs: "100%", lg: "50%" } }}
        multiline
        placeholder="Enter your company Description (50-100 words)"
        value={value ?? formik.values[name]}
        onChange={formik.handleChange}
        error={Boolean(formik.touched[name] && formik.errors[name])}
        helperText={formik.touched[name] && formik.errors[name]}
        slotProps={{
          htmlInput: {
            maxLength: 500,
          },
        }}
      />
      <Typography
        sx={{ marginTop: "5px", color: "#535862", fontSize: "small" }}
      >
        {500 - (formik?.values[name].length || 0)} characters left
      </Typography>
    </>
  );
};

export default BioFieldInput;
